import { registerService } from './lib';

export type FiatManagerPaymentMethod = {
  name: string;
  icon: string;
  id: string;
};

declare module './lib' {
  interface ServiceRegistry {
    'fiat-manager': ServiceEndpoints<{
      'post:payment/create/': {
        params: {
          amount: string;
          callback_url: string;
        };
        response: {
          payment_link: string;
        };
      };
      'get:payment/{slug}/': {
        params: {
          slug: string;
        };
        response: {
          success: boolean;
        };
      };
      'get:payment-methods/': {
        response: FiatManagerPaymentMethod[];
      };
    }>;
  }
}

registerService('fiat-manager', '/proxy/fiat-manager');
